import React, { useState } from "react";

export function SearchPanel(props) {
  const [inputValue, setInputValue] = useState(""); // State to store input value

  function handleChange(event) {
    setInputValue(event.target.value); // Update state on input change
    if (props.type === "live") {
      props.setSearch(event.target.value);
    }
  }

  function handleClick() {
    props.setSearch(inputValue); // Use the state value when button is clicked v
  }

  return (
    <div className="SearchPanel">
      <input
        ref={props.searchRef}
        type="text"
        value={inputValue}
        id="search-input"
        placeholder={props.placeholder ? props.placeholder : "Sök..."}
        onChange={handleChange}
        onKeyPress={(event) => {
          if (event.key === "Enter") {
            event.preventDefault();
            props.pickEnter && props.pickEnter();
            handleClick();
            if (props.type === "live") {
              setInputValue("");
            }
          }
        }}
      />
      {props.live ? (
        ""
      ) : (
        <button
          id="search-button"
          className="hoverButton"
          onClick={handleClick}
        >
          Sök
        </button>
      )}
    </div>
  );
}
